import styles from '../styles/Header.module.sass';

import { FC } from 'react';
import { FlexboxGrid, IconButton } from 'rsuite';

export interface HeaderProps {
  section: string;
  open: boolean;
  setOpen: (val: boolean) => void;
}

const HeaderContent: FC<HeaderProps> = ({ section, open, setOpen }) => {
  return (
    <FlexboxGrid
      className={styles.bar}
      justify="center"
      align="middle" 
      style={{
        padding: '20px 56px',
        backgroundColor: '#F9F9FE',
        left: '0px !important'
      }}
    >
      {
        !open ?
        (
          <FlexboxGrid.Item>
            <IconButton
              appearance="subtle"
              icon={
                <img src="/svg/menu.svg" alt="Menu icon" />
              }
              onClick={()=>setOpen(true)}
            />
          </FlexboxGrid.Item>
        ) : ''
      }
      <FlexboxGrid.Item >
        <h3 className="sub-heading">{ section }</h3>
      </FlexboxGrid.Item>      
    </FlexboxGrid>
  );
};

export default HeaderContent;